import { render } from "./PhoneMockup.vue?vue&type=template&id=317e6877&scoped=true"
import script from "./PhoneMockup.vue?vue&type=script&lang=js"
export * from "./PhoneMockup.vue?vue&type=script&lang=js"

import "./PhoneMockup.vue?vue&type=style&index=0&id=317e6877&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317e6877"]])

export default __exports__